﻿import React from 'react';

export default () => {
  return <div
    className='absolute bottom-0 left-0 w-full h-full rounded-b-32'
    style={{
      mask: 'linear-gradient(0deg, black, black, transparent)',
      WebkitMask: 'linear-gradient(0deg, black, black, transparent)',
      backdropFilter: 'blur(2px)',
      WebkitBackdropFilter: 'blur(2px)',
    }}
  />;
};